import {
	IncludedGdsServicesFragment,
	GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment as BaggageServiceFragment
} from '@websky/graphql';
import { getIncludedBaggageWeightValue } from '@shared/lib/gdsService';
import { Baggage, SelectedBaggageItem } from '../../../../BaggageService/types';

export function convertIncludedBaggageToSelected(
	travellerId: string,
	includedService: IncludedGdsServicesFragment
): SelectedBaggageItem {
	const { serviceId, segmentIds, confirmedCount, service } = includedService;
	const baggageService = service as BaggageServiceFragment;

	const baggage: Baggage = {
		id: serviceId,
		includedSegments: segmentIds,
		included: confirmedCount,

		segmentIds: baggageService.allowedSegments,
		type: baggageService.baggageType,
		name: baggageService.name,
		description: baggageService.description,
		value: getIncludedBaggageWeightValue(baggageService.baggageWeight),
		size: baggageService.size,
		price: baggageService.price,
		rfics: baggageService.rfisc,
		canBeAdded: false,
		allowedPassengers: [travellerId],
		isReplacedBy: baggageService.isReplacedBy
	};

	return { ...includedService, baggage, passengerId: travellerId };
}
